import { ContainerTypeEnum, Currency, Incoterms, PaymentMethod, SourceChoiceEnum } from 'api';
import { yup } from 'form';

const AddressDetailsSchema = yup
  .object({
    country_code: yup.string().optional(),
    full_address: yup.string().optional(),
    latitude: yup.number().optional(),
    longitude: yup.number().optional(),
  })
  .nullable();

export const dealProfitabilityCalculatorSchema = yup
  .object({
    buyer: yup.number().notRequired(),
    buyer_agent_commission: yup.number().required(),
    buyer_agent_commission_currency: yup.string().oneOf(Object.values(Currency)).required(),
    buyer_currency: yup.string().oneOf(Object.values(Currency)).required(),
    buyer_deposit_percentage: yup.number().required(),
    buyer_due_date_offset: yup.number().required(),
    buyer_due_date_offset_direction: yup.number().required(),
    buyer_payment_event: yup.string().optional(),
    buyer_price_per_tonne: yup.number().required(),
    buyer_site: yup.number().notRequired(),
    container_type: yup.string().oneOf(Object.values(ContainerTypeEnum)).required(),
    demand_incoterm: yup.string().oneOf(Object.values(Incoterms)).optional(),
    destination_address: AddressDetailsSchema.notRequired(),
    destination_port_country: yup.string().notRequired(),
    estimated_transit_time_days: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === '' ? undefined : value;
      })
      .optional(),
    material: yup.number().required(),
    origin_address: AddressDetailsSchema.notRequired(),
    origin_port_country: yup.string().notRequired(),
    pern_currency: yup.string().oneOf(Object.values(Currency)).required(),
    pern_revenue_per_tonne: yup.number().required(),
    port_of_discharge: yup.number().notRequired(),
    port_of_loading: yup.number().notRequired(),
    purchaser_payment_method: yup.string().oneOf(Object.values(PaymentMethod)).optional(),
    seller: yup.number().notRequired(),
    seller_agent_commission: yup.number().required(),
    seller_agent_commission_currency: yup.string().oneOf(Object.values(Currency)).required(),
    seller_currency: yup.string().oneOf(Object.values(Currency)).required(),
    seller_deposit_percentage: yup.number().required(),
    seller_due_date_offset: yup.number().required(),
    seller_due_date_offset_direction: yup.number().required(),
    seller_payment_event: yup.string().optional(),
    seller_price_per_tonne: yup.number().required(),
    seller_site: yup.number().notRequired(),
    shipping_cost_per_load: yup.number().required(),
    shipping_cost_per_load_currency: yup.string().oneOf(Object.values(Currency)).required(),
    supply_incoterm: yup.string().oneOf(Object.values(Incoterms)).optional(),
    tonnes: yup.number().required(),
    tonnes_per_load: yup.number().required(),
    transit_time_estimate: yup.object().notRequired(),
    transport_cost_currency: yup.string().oneOf(Object.values(Currency)).required(),
    transport_cost_source: yup
      .string()
      .oneOf(Object.values(SourceChoiceEnum))
      .required()
      .default(SourceChoiceEnum.ESTIMATE),
    transport_price: yup.object().notRequired(),
  })
  .required();
